import type { ReactNode } from 'react';
type Tone = 'accent' | 'soft' | 'neutral' | 'success';
const tones: Record<Tone, string> = {
  accent: 'bg-clay text-shell',
  soft: 'bg-blush text-ink',
  neutral: 'bg-sand text-muted',
  // Donkerder dan de sage-token zelf: 5,4:1 op het lichte sage-vlak.
  success: 'bg-sage/10 text-sage'
};

/** Klein statuslabel — overal dezelfde maat en vorm. */
export function Badge({
  tone = 'neutral',
  children
}: {
  tone?: Tone;
  children: ReactNode;
}) {
  return <span className={`inline-flex shrink-0 items-center rounded-full px-2.5 py-0.5 text-[12px] leading-5 ${tones[tone]}`} data-id="element-4897" data-mp="2pj85ifidt3ou">{children}</span>;
}